import { boot } from "@kit/boot";
import { game } from "./index";
import { t } from "./i18n";

boot({ id: game.meta.id, scenes: game.scenes, instructions: t("instructions") });
